import { LogLevel } from "@azure/msal-browser";
import { host } from "../globalVariables";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export async function fetchAuthConfig() {
   const res = await fetch(host + "/api/config/auth");
   if (!res.ok) throw new Error("Auth-Konfiguration konnte nicht geladen werden");
   return res.json(); // { clientId, tenantId }
}

export function buildMsalConfig({ clientId, tenantId, redirectUrl }) {
   return {
      auth: {
         clientId,
         authority: `https://login.microsoftonline.com/${tenantId}`,
         redirectUri: import.meta.env.PROD
            ? "https://" + redirectUrl //"https://programme.baur-immobilien.de/"
            : "http://localhost:5173/",
         postLogoutRedirectUri: "/",
         navigateToLoginRequestUrl: true,
      },
      cache: {
         cacheLocation: "localStorage",
         temporaryCacheLocation: "localStorage",
         storeAuthStateInCookie: false,
      },
      system: {
         loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
               if (containsPii) return;
               switch (level) {
                  case LogLevel.Error:
                     console.error(message);
                     return;
                  case LogLevel.Warning:
                     console.warn(message);
                     return;
                  case LogLevel.Verbose:
                     console.debug(message);
                     return;
                  default:
                     return;
               }
            },
         },
      },
   };
}

export const msalConfig = {
   auth: {
      clientId: "9ef24065-0631-4d47-89f5-69ec838eeff9", // CRM2 This is the ONLY mandatory field that you need to supply.
      authority: "https://login.microsoftonline.com/f6e03af0-f62c-4ef2-a542-c02a29109b93", // Replace the placeholder with your tenant info
      redirectUri: import.meta.env.PROD ? "https://programme.baur-immobilien.de/" : "http://localhost:5173/", // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.

      postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
      navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
   },
   cache: {
      cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
      temporaryCacheLocation: "localStorage",
      // cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
      // temporaryCacheLocation: "sessionStorage",
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
   },
   system: {
      loggerOptions: {
         loggerCallback: (level, message, containsPii) => {
            if (containsPii) {
               return;
            }
            switch (level) {
               case LogLevel.Error:
                  console.error(message);
                  return;
               case LogLevel.Info:
                  // console.info(message);
                  return;
               case LogLevel.Verbose:
                  console.debug(message);
                  return;
               case LogLevel.Warning:
                  console.warn(message);
                  return;
               default:
                  return;
            }
         },
      },
   },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
   scopes: [
      "Sites.Read.All",
      "User.Read",
      "Files.ReadWrite.All",
      "ChatMessage.Send",
      "ChannelMessage.Send",
      "Chat.Read",
      "Chat.ReadBasic",
      "User.ReadBasic.All",
      "Chat.Create",
   ],
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
// export const silentRequest = {
//     scopes: ["openid", "profile"],
//     loginHint: "example@domain.net"
// };
